import React from "react";
import { FieldRendererProps } from "../types";
import { AlertField } from "../../alerta-campo";

export const AlertFieldRenderer: React.FC<FieldRendererProps> = ({ campo }) => (
  <AlertField campo={campo} />
);
